let base_url="http://127.0.0.1:8089"
// let base_url="/prod-api"

export default base_url



// WEBPACK FOOTER //
// ./src/utils/Constants.js